<script lang="ts" setup>
import { tpgIconSend } from '@tpg/grammar-web-icons';
import { ref } from 'vue';

import { GrammarQuaternaryButton } from '@nora-monorepo/grammar-ui';
import type { GroupResultDTO } from '@nora-monorepo/nora-api-client';
import { formatName } from '@nora-monorepo/shared';
import {
  AvatarImage,
  borderSeparatorTransparency,
  textBlue,
  textPrimary,
} from '@nora-monorepo/ui-shared';
import type { UserWithLocalRole } from '@nora-monorepo/ui-shared';

import { ConversationModalActionState } from '#nora-chat-ui/components/modals/new-conversation/conversation-modal-types';
import ConversationModal from '#nora-chat-ui/components/modals/new-conversation/ConversationModal.vue';
import { highlight as vHighlight } from '#nora-chat-ui/utils/highlight';

interface GroupItemProps {
  group: GroupResultDTO;
  highlightText: string;
  showStartConversationButton?: boolean;
}
const props = defineProps<GroupItemProps>();
const showCreateConversationModal = ref(false);
const initialUsers = ref<UserWithLocalRole['user'][]>([]);
const initialGroups = ref<GroupResultDTO[]>([]);

async function toggleNewConversationModal() {
  initialUsers.value = [];
  initialGroups.value = [props.group];
  showCreateConversationModal.value = true;
}

function closeCreateConversationModal() {
  showCreateConversationModal.value = false;
  initialUsers.value = [];
  initialGroups.value = [];
}
</script>

<template>
  <ConversationModal
    v-if="showCreateConversationModal"
    :is-open="showCreateConversationModal"
    :mode="ConversationModalActionState.Create"
    :initial-users="initialUsers"
    :initial-groups="initialGroups"
    @close="closeCreateConversationModal"
  />
  <div class="flex pr-2 w-full cursor-pointer">
    <div class="px-2 py-3">
      <AvatarImage
        :id="group.id"
        icon="groups"
      />
    </div>
    <div
      class="flex items-center justify-between w-full overflow-hidden py-2 border-b"
      :class="borderSeparatorTransparency"
    >
      <div class="flex">
        <span
          v-highlight="{
            text: highlightText ?? '',
            class: `${textBlue} font-bold`,
          }"
          class="font-semibold text-ellipsis overflow-hidden whitespace-nowrap mr-1"
          :class="textPrimary"
        >
          {{ formatName(props.group) }}
        </span>
      </div>

      <GrammarQuaternaryButton
        :icon-template="tpgIconSend"
        @click="toggleNewConversationModal"
      />
    </div>
  </div>
</template>
